import { formulaireCatalogueMock, titreDescriptionMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [titreDescriptionMock(true, false), formulaireCatalogueMock];

export const catalogueMock: SlugPage = {
  ...pageBase({
    title: 'Catalogue',
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
